export const routineInspectionUpdateRespondDetails = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_UPDATE_RESPONDED_DETAILS",
    payload: details,
  });
  
  export const routineInspectionUpdateothereRespondedDetails = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_UPDATE_OTHER_RESPONDED_DETAILS",
    payload: details,
  });
  
  export const routineInspectionUpdateCompletionInfoDetails = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_UPDATE_COMPLETION_DETAILS",
    payload: details,
  });
  
  export const routineInspectionAddRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
    payload: details,
  });
  
  export const routineInspectionUpdateRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_UPDATE_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
    payload: details,
  });
  
  export const routineInspectionAddPartReplacementDetailsForVendor = (type, details) => ({
    type:type,
    //"ROUTINEINSPECTION_PART_REPLACEMENT_FOR_VENDOR",
    payload: details,
  });
  
  export const routineInspectionUpdatePartReplacementDetailsForVendor = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_UPDATE_PART_REPLACEMENT_FOR_VENDOR",
    payload: details,
  });
  
  export const routineInspectionClearPartRepalacementForVendor = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_CLEAR_PART_REPLACEMENT_FOR_VENDOR",
    payload: details,
  });
  
  export const routineInspectionDeleteRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_DELETE_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
    payload: details,
  });
  
  export const routineInspectionClearRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_CLEAR_REPAIR_TRACKER_FOR_VENDOR",
    payload: details,
  });
  
  
  export const routineInspectionCheckFormSubmitForVendor = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_UPDATE_FORMSUBMIT_STATUS",
    payload: details,
  });
  
  export const routineInspectionClearWebForm = (type, details) => ({
    type: type,
    //"ROUTINEINSPECTION_CLEAR_WEB_FORM",
    payload: details,
  });
  
  export const getRoutineInspectionVendorName = (type, details) => ({
    type: type,
    //"GET_ROUTINEINSPECTION_VENDORNAME",
    payload: details,
  });
  